export default "__VITE_ASSET__Bkd3UY9v__"